import React from "react";
import { Form, Formik } from "formik";
import {
  Autocomplete,
  Box,
  Button,
  DialogActions,
  TextField,
  Switch,
} from "@mui/material";
import { useQuestionsForm } from "../hooks/useQuestionsForm";

function QuestionsForm({
  editMode,
  currentPrincipleQuestion,
  setOpen,
  handleClose,

  page,
  limit,
  search,
  sort,
  searchInput,
  location,
}) {
  const {
    validationSchema,
    initialValues,
    handleSubmit,
    principleSearchResults,
    setSearchPrincipleTerm,
    availableLocations,
    showOrg,
  } = useQuestionsForm({
    editMode,
    currentPrincipleQuestion,
    setOpen,

    page,
    limit,
    search,
    sort,
    searchInput,
    location,
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({
        isSubmitting,
        getFieldProps,
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
      }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <Box sx={{ p: 3 }}>
              <TextField
                fullWidth
                id="question"
                name="question"
                label="Question"
                variant="outlined"
                margin="normal"
                value={values.question}
                onChange={handleChange}
                onBlur={handleBlur}
                {...getFieldProps("question")}
                error={touched.question && Boolean(errors.question)}
                helperText={touched.question && errors.question}
              />

              <TextField
                fullWidth
                id="url"
                name="url"
                label="URL"
                variant="outlined"
                margin="normal"
                value={values.url}
                onChange={handleChange}
                onBlur={handleBlur}
                {...getFieldProps("url")}
                error={touched.url && Boolean(errors.url)}
                helperText={touched.url && errors.url}
              />

              <Autocomplete
                fullWidth
                options={principleSearchResults}
                getOptionLabel={(option) =>
                  option
                    ? `Principle ${option.principleNumber} - ${option.name}`
                    : ""
                }
                noOptionsText="No principles found"
                value={
                  values.principle && Object.keys(values.principle).length > 0
                    ? values.principle
                    : null
                }
                onInputChange={(event, newInputValue) => {
                  setSearchPrincipleTerm(newInputValue);
                }}
                onChange={(e, value) => setFieldValue("principle", value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="Principle"
                    variant="outlined"
                    margin="normal"
                    error={touched.principle && Boolean(errors.principle)}
                    helperText={touched.principle && errors.principle}
                  />
                )}
              />
              {!editMode && showOrg && (
                <Autocomplete
                  multiple
                  fullWidth
                  options={availableLocations}
                  getOptionLabel={(option) => option.name}
                  noOptionsText="No locations found"
                  value={values.location} // Ensure it's using the array of selected locations
                  onChange={(e, value) => setFieldValue("location", value)}
                  isOptionEqualToValue={(option, value) =>
                    option._id === value._id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      label="Location"
                      variant="outlined"
                      margin="normal"
                      error={touched.location && Boolean(errors.location)}
                      helperText={touched.location && errors.location}
                    />
                  )}
                />
              )}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 2,
                }}
              >
                <Switch
                  checked={values.priority}
                  onChange={(e) => setFieldValue("priority", e.target.checked)}
                  color="primary"
                />
                <span>Mark as Priority</span>
              </Box>

              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button type="submit" color="primary" disabled={isSubmitting}>
                  {editMode ? "Update" : "Create"}
                </Button>
              </DialogActions>
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
}

export default QuestionsForm;
